<template>
    <div class="stockMessageBar">
        {{ stockMessage }}
    </div>
</template>

<script>
    export default {
        computed: {
            stockMessage() {
                return this.$root.stockMessage;
            }
        }
    }
</script>
